/* GC — "GELİNCE HABER VER" (Preorder/Restock Duck "peppy" app) buton metnini
   temanın "TÜKENDİ" butonu (.xo-btn__text) ile eşitler, sonra istenen kadar küçültür.
   Neden JS? App font'u INLINE !important basıyor (e.style.setProperty(p,v,"important")),
   harici CSS bunu yenemez. Çözüm: canlı TÜKENDİ butonundan getComputedStyle ile gerçek px
   okuyup peppy butona inline !important uygula.
   ÖNEMLİ: app butonu .peppy-notify-me-button VEYA tema-stili .peppy-notify-me-button-custom
   varyantı olarak basabiliyor -> her iki sınıfı da hedeflemeliyiz. */
(function () {
  if (window.__gcPeppyMatch) return;
  window.__gcPeppyMatch = true;

  // TÜKENDİ'den kaç pt KÜÇÜK olsun (kullanıcı ayarı). 1pt = 96/72 px.
  var REDUCE_PT = -0.5; // negatif = TÜKENDİ'den BÜYÜK (çok az bir tık)
  var REDUCE_PX = REDUCE_PT * 96 / 72;

  var BTN_SEL = '.peppy-notify-me-button, .peppy-notify-me-button-custom,'
              + '.peppy-notify-me-button-float-right, .peppy-notify-me-button-float-right-custom';
  // Modaldaki "Powered by Peppyduck" rozeti — app inline display:block !important basıyor, JS ile gizle
  var BRAND_SEL = '#peppy-form-branding, .peppy-popup-form-branding, .peppy-popup-form-branding-custom';
  var OBS_OPT = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] };
  var obs;

  function sourceCS() {
    var el = document.querySelector('xo-product .xo-btn--block .xo-btn__text')
          || document.querySelector('xo-product .xo-btn__text')
          || document.querySelector('.xo-btn__text');
    return el ? getComputedStyle(el) : null;
  }

  function hideBranding() {
    var els = document.querySelectorAll(BRAND_SEL);
    for (var i = 0; i < els.length; i++) {
      if (els[i].style.getPropertyValue('display') !== 'none') {
        els[i].style.setProperty('display', 'none', 'important');
      }
    }
  }

  function apply() {
    hideBranding();
    var btns = document.querySelectorAll(BTN_SEL);
    if (!btns.length) return;
    var cs = sourceCS();
    if (!cs) return;
    var base = parseFloat(cs.fontSize) || 16;
    var fs = Math.max(6, base - REDUCE_PX) + 'px';            // min 6px güvenlik
    var ls = (cs.letterSpacing && cs.letterSpacing !== 'normal') ? cs.letterSpacing : '0.16rem';
    var fw = cs.fontWeight || '500';
    var ff = cs.fontFamily || 'inherit';
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.style.getPropertyValue('font-size') === fs) continue; // zaten doğruysa atla (loop koruması)
      b.style.setProperty('font-size', fs, 'important');
      b.style.setProperty('letter-spacing', ls, 'important');
      b.style.setProperty('font-weight', fw, 'important');
      b.style.setProperty('font-family', ff, 'important');
      b.style.setProperty('text-transform', 'uppercase', 'important');
      b.style.setProperty('color', '#fff', 'important');
    }
  }

  function safeApply() {
    if (obs) obs.disconnect();
    try { apply(); } catch (e) {}
    if (obs) obs.observe(document.body, OBS_OPT);
  }

  function init() {
    obs = new MutationObserver(safeApply);
    safeApply();
    [150, 400, 800, 1500, 2800, 5000].forEach(function (t) { setTimeout(safeApply, t); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* GC — Koleksiyon kartındaki "GELİNCE HABER VER" butonu ürün sayfasına
   ?haberver=1 ile geliyor (bkz. snippets/gc-notify-card-button.liquid).
   Burada o parametreyi görüp app'in butonuna otomatik basıyoruz, böylece
   müşteri ikinci kez tıklamak zorunda kalmıyor.
   Neden yoklama (polling)? Peppyduck butonu asenkron kuruyor ve stok/varyant
   kontrolünden sonra display:block yapıyor; hazır olmadan tıklamak boşa gidiyor.
   Tıklama dinleyicisi app tarafında CONTAINER üzerinde, o yüzden container'a basıyoruz. */
(function () {
  if (window.__gcNotifyAutoOpen) return;
  window.__gcNotifyAutoOpen = true;

  if (location.pathname.indexOf('/products/') === -1) return;
  if (!/[?&]haberver=1(&|$)/.test(location.search)) return;

  var BTN_SEL = '.peppy-notify-me-button-container, .peppy-notify-me-button-container-custom,'
              + '.peppy-notify-me-button-container-float-right,'
              + '.peppy-notify-me-button-container-float-right-custom';
  var MAX_TRIES = 60;  // 60 x 250ms = ~15sn; app hiç açılmazsa sessizce vazgeç
  var tries = 0;

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null) return false;              // display:none zinciri
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  function cleanUrl() {
    // Yenilemede/geri gelmede form tekrar açılmasın diye parametreyi adresten düşür.
    try {
      var u = new URL(location.href);
      u.searchParams.delete('haberver');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function tick() {
    var el = document.querySelector(BTN_SEL);
    if (isVisible(el)) {
      cleanUrl();
      try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      setTimeout(function () { el.click(); }, 300);
      return;
    }
    if (++tries < MAX_TRIES) setTimeout(tick, 250);
  }

  if (document.readyState !== 'loading') tick();
  else document.addEventListener('DOMContentLoaded', tick);
})();
